import clsx from "clsx";

export type HorizontalBarDataPoint = {
    value: number;
    color: string;
};

export type HorizontalBarProps = {
    data: HorizontalBarDataPoint[];
    total: number;
};

const HorizontalBar = ({ data, total }: HorizontalBarProps) => {
    return (
        <div className="flex h-2">
            {data.map((dataPoint) => (
                <div
                    key={dataPoint.color}
                    className={clsx(dataPoint.color, "h-2")}
                    style={{ width: `${(dataPoint.value / total) * 100}%` }}
                ></div>
            ))}
            <div className="white" style={{ width: `${total - total}%` }}></div>
        </div>
    );
};

export default HorizontalBar;
